// extracted by mini-css-extract-plugin
module.exports = {"ProfileName":"ProfileName_ProfileName__fcsz2","katagaki":"ProfileName_katagaki___lTkt"};